import React from 'react'
import styled from 'styled-components/macro'

const ErrorFallback = ({ error }) => (
    <Container>
        <Content>
            <h1>Error</h1>
            <p>Sorry, we encountered unexpected error</p>
            <p>{error && error.toString()}</p>
        </Content>
    </Container>
)

const Container = styled.section `
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
`
const Content = styled.div `
  width: 100%;
  max-width: 600px;
`
export default ErrorFallback